var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWarnYellow = function SvgIconWarnYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCCC50",
    d: "M3.003 20.92a1.127 1.127 0 0 1-.975-1.688L11.025 3.65a1.126 1.126 0 0 1 1.95 0l8.997 15.583a1.126 1.126 0 0 1-.975 1.689z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCCC50",
    d: "M12 3.461a.74.74 0 0 1 .65.375l8.997 15.584a.75.75 0 0 1-.65 1.126H3.003a.75.75 0 0 1-.65-1.126L11.35 3.836a.74.74 0 0 1 .65-.375m0-.75a1.49 1.49 0 0 0-1.3.75L1.703 19.045a1.5 1.5 0 0 0 1.3 2.251h17.994a1.5 1.5 0 0 0 1.3-2.25L13.299 3.46a1.49 1.49 0 0 0-1.3-.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M12 18.375a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M12.75 8.625a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0z"
  })));
};
export default SvgIconWarnYellow;